module.exports = __webpack_public_path__ + "static/media/evs.7ecb7d33.png";